export default __webpack_public_path__ + "static/media/endorsement-kujang.a7ef23a9.jpg";